/* SicilyAddict DE - PDP
   1. Card AOV a quantità: cliccando una card si imposta la quantità nel form prodotto; se il cliente
      cambia la quantità a mano, la card corrispondente si evidenzia (o nessuna). Il prezzo grande
      mostra il prezzo della card attiva, o prezzo unitario x quantità. Sconto Mix & Match e minimo
      d'ordine ricalcolati dal vivo sul carrello (/cart.js) quando il carrello cambia.
   2. Quantità accanto all'Add to Cart (Golden Master): il selettore quantità viene spostato nella
      stessa riga del bottone. È solo uno spostamento nel DOM, il form resta lo stesso.
   3. Consegna stimata: se il blocco ha un orario limite, la barra verde mostra la data calcolata
      (giorni di spedizione + transito). Senza orario limite resta il testo fisso dalla fonte unica.
   4-6. Video preparazione, bundle multi-prodotto, apertura recensioni.
   7. Barra acquisto fissa in basso (mobile; desktop se attivato nel blocco Buy buttons).
   8. Kit (metafield custom.kit_komponenten): il pulsante aggiunge le varianti componenti, mai il kit. */
(function () {
  /* ---------- 1. AOV ---------- */
  /* Formattazione come il server (shop.money_format in data-money); le entita' (&euro;) vengono decodificate. */
  function aovMoney(root, cents) {
    var f = root.dataset.money || '{{amount_with_comma_separator}} €';
    var n = (Math.max(0, cents) / 100).toFixed(2);
    var de = n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var en = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var s = f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, de).replace(/\{\{\s*amount\s*\}\}/, en)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0]).replace(/<[^>]*>/g, '');
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }
  function aovEl(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
 
  function initAov(root) {
    if (root.dataset.saAovReady) return;
    root.dataset.saAovReady = '1';
    var form = root.closest('form') || document.getElementById(root.dataset.formId);
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sa-aov-qty]'));
    /* DEV Spec 01: il click sulla card aggiorna selezione E prezzo. Il prezzo grande mostra il prezzo
       della card attiva (anche con 1 box, se la card ha lo sconto Mix & Match); altrimenti prezzo unitario x quantita'. */
    var priceEl = form.querySelector('.price-list .price:not(.price--compare)');
    var priceOrig = priceEl ? priceEl.innerHTML : '';
    var unit = parseInt(root.dataset.unit, 10) || 0;
    function sync() {
      syncPrice();
      document.dispatchEvent(new CustomEvent('sa:aov:sync', { detail: { form: form } }));
    }
    function syncPrice() {
      var q = parseInt(qty.value, 10) || 1;
      var active = null;
      cards.forEach(function (c) {
        var on = parseInt(c.dataset.saAovQty, 10) === q;
        if (on) active = c;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (!priceEl) return;
      var discounted = active && parseFloat(active.dataset.saAovP || '0') > 0;
      if (q <= 1 && !discounted) { priceEl.innerHTML = priceOrig; return; }
      var hidden = priceEl.querySelector('.visually-hidden');
      var cur = active && active.querySelector('.sa-aov__current');
      var txt = cur ? cur.textContent.trim() : (unit ? aovMoney(root, unit * q) : '');
      if (!txt) return;
      priceEl.textContent = txt;
      if (hidden) priceEl.insertBefore(hidden, priceEl.firstChild);
    }
 
    /* ---- Mix & Match: ricalcolo dal vivo con i dati del carrello (/cart.js) ----
       Stesse regole del Liquid (snippets/sa-de-aov.liquid): soglia per (box idonee nel carrello + n),
       righe idonee del carrello ricalcolate alla nuova soglia, minimo d'ordine sul totale risultante. */
    var d = root.dataset;
    var mixOk = d.mix === '1';
    var tiers = (d.mixTiers || '').replace(/[\s%]/g, '').replace(/;/g, ',').split(',').map(function (s) {
      var kv = s.split(':');
      return [parseFloat(kv[0]) || 0, parseFloat(kv[1]) || 0];
    }).filter(function (t) { return t[0] > 0 && t[1] > 0; });
    var ids = {};
    try {
      var idsEl = root.querySelector('[data-sa-mix-ids]');
      (idsEl ? JSON.parse(idsEl.textContent || '[]') : []).forEach(function (id) { ids[String(id)] = 1; });
    } catch (e) {}
    if (mixOk && d.productId) ids[String(d.productId)] = 1;
    /* Ordine minimo spento (data-min-enabled=0): nessun chip "Mindestbestellwert erreicht" e nessuna nota */
    var minC = d.minEnabled === '1' ? (parseInt(d.min, 10) || 0) : 0;
    var gratis = d.gratis ? parseInt(d.gratis, 10) : null;
    var s1b = d.s1b ? parseInt(d.s1b, 10) : null;
 
    function tierFor(count) {
      var p = 0;
      tiers.forEach(function (t) { if (count >= t[0] && t[1] > p) p = t[1]; });
      return p;
    }
    function renderCard(c, st) {
      var n = parseInt(c.dataset.saAovQty, 10) || 1;
      var total = unit * n;
      var p = mixOk ? tierFor(st.elig + n) : 0;
      var pay = p > 0 ? Math.floor((100 - p) * total / 100) : total;
      var base = st.total;
      if (mixOk) base = st.total - st.eligFinal + Math.floor((100 - p) * st.eligOrig / 100);
      var proj = base + pay;
      var kind = '';
      if (minC > 0 && proj < minC) kind = 'min';
      else if (s1b !== null && d.s1Text && proj <= s1b) kind = 's1';
      else if (gratis !== null && d.s2Text && proj < gratis) kind = 's2';
      else if (gratis !== null && proj >= gratis) kind = 'free';
      var unlock = minC > 0 && kind !== 'min' && !!d.unlock;
      var pTxt = String(p).replace('.', ',');
      c.dataset.saAovP = String(p);
 
      var price = c.querySelector('.sa-aov__price');
      if (price) {
        price.textContent = '';
        if (p > 0 && d.fmtBadge) price.appendChild(aovEl('span', 'sa-aov__rabatt', d.fmtBadge.replace('{prozent}', pTxt)));
        price.appendChild(aovEl('span', 'sa-aov__current', aovMoney(root, pay)));
        if (p > 0) price.appendChild(aovEl('span', 'sa-aov__old', aovMoney(root, total)));
        if (c.dataset.perShow === '1') {
          var per = Math.floor(pay / (parseInt(c.dataset.perCount, 10) || n));
          price.appendChild(aovEl('span', 'sa-aov__per', '= ' + aovMoney(root, per) + ' pro ' + (c.dataset.perLabel || '')));
        }
        if (kind === 'min' && d.minText) {
          price.appendChild(aovEl('span', 'sa-aov__ship sa-aov__ship--warn',
            d.minText.replace('{fehlt}', aovMoney(root, minC - proj)).replace('{betrag}', aovMoney(root, minC))));
        } else if (d.shipCost === '1' && (kind === 's1' || kind === 's2')) {
          price.appendChild(aovEl('span', 'sa-aov__ship', kind === 's1' ? d.s1Text : d.s2Text));
        }
      }
 
      var bottom = c.querySelector('.sa-aov__bottom');
      var chips = [];
      if (p > 0) chips.push(['save', '✓', pTxt + ' %' + (d.labelRabatt ? ' ' + d.labelRabatt : '')]);
      if (unlock) chips.push(['unlock', '🔓', d.unlock]);
      if (kind === 'free') chips.push(['free', '🚚', d.free || '']);
      if (!chips.length) { if (bottom) bottom.parentNode.removeChild(bottom); return; }
      if (!bottom) { bottom = aovEl('span', 'sa-aov__bottom'); c.appendChild(bottom); }
      bottom.textContent = '';
      chips.forEach(function (ch) {
        var b = aovEl('span', 'sa-aov__benefit sa-aov__benefit--' + ch[0]);
        var ic = aovEl('span', 'sa-aov__check', ch[1]);
        ic.setAttribute('aria-hidden', 'true');
        b.appendChild(ic);
        b.appendChild(aovEl('span', null, ch[2]));
        bottom.appendChild(b);
      });
    }
    root._saAovApply = function (cart) {
      if (!cart || !cart.items) return;
      var st = { elig: 0, eligOrig: 0, eligFinal: 0, total: parseInt(cart.total_price, 10) || 0 };
      cart.items.forEach(function (it) {
        if (!ids[String(it.product_id)]) return;
        st.elig += parseInt(it.quantity, 10) || 0;
        st.eligOrig += parseInt(it.original_line_price, 10) || 0;
        st.eligFinal += parseInt(it.final_line_price, 10) || 0;
      });
      cards.forEach(function (c) { renderCard(c, st); });
      sync();
    };
 
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        qty.value = c.dataset.saAovQty;
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
    });
    qty.addEventListener('input', sync);
    qty.addEventListener('change', sync);
    form.querySelectorAll('.quantity-selector__button').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(sync, 0); });
    });
    sync();
    aovRefreshCart();
  }
 
  /* Carrello cambiato senza ricaricare la pagina (aggiunta dalla PDP, upsell/bundle, quantita' nel carrello a
     scomparsa): si rilegge /cart.js e si ricalcolano tutte le card. Eventi del tema Warehouse e degli script SA
     (product:added, cart:refresh, cart:rerendered, cart:updated) + qualsiasi fetch verso /cart/add|change|update|clear. */
  var aovTimer = null;
  function aovRefreshCart() {
    if (!document.querySelector('[data-sa-aov]')) return;
    clearTimeout(aovTimer);
    aovTimer = setTimeout(function () {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      (window.saAovFetch || window.fetch).call(window, base + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('[data-sa-aov]').forEach(function (root) { if (root._saAovApply) root._saAovApply(cart); });
        })
        .catch(function () {});
    }, 120);
  }
  ['product:added', 'cart:refresh', 'cart:rerendered', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, aovRefreshCart);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) aovRefreshCart(); });
  if (window.fetch && !window.saAovFetch) {
    window.saAovFetch = window.fetch;
    window.fetch = function (input, init) {
      var p = window.saAovFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function () { aovRefreshCart(); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }
 
  /* ---------- 2. Quantità + ATC sulla stessa riga ----------
     Si sposta l'intero <buy-button> (non il solo bottone, che perderebbe l'aggiunta AJAX del tema)
     e la riga va PRIMA del contenitore pagamenti: dentro quel contenitore il bottone dividerebbe
     la riga con il bottone PayPal e si schiaccerebbe. */
  function initQtyRow(form) {
    /* SA DE 21/10/2026: al cambio variante il tema ridisegna lista info e pulsanti, ma la riga
       spostata da qui restava con quantita' e ATC vecchi (doppioni). Ora si usano sempre gli
       elementi nuovi e la riga vecchia si elimina, cosi' resta una sola riga quantita' + ATC. */
    var outside = function (sel) {
      var list = form.querySelectorAll(sel);
      for (var i = 0; i < list.length; i++) { if (!list[i].closest('.sa-qty-atc')) return list[i]; }
      return null;
    };
    var oldRow = form.querySelector('.sa-qty-atc');
    var freshQty = outside('.product-form__info-item--quantity');
    var freshBtn = outside('.product-form__add-button');
    if (oldRow && !freshQty && !freshBtn) return;
    var qtyItem = freshQty || (oldRow && oldRow.querySelector('.product-form__info-item--quantity'));
    var btn = freshBtn || (oldRow && oldRow.querySelector('.product-form__add-button'));
    if (!qtyItem || !btn) return;
    var atc = btn.closest('buy-button') || btn;
    var anchor = atc.closest('.sa-qty-atc') || atc.closest('.product-form__payment-container') || atc;
    form.dataset.saQtyRow = '1';
    var row = document.createElement('div');
    row.className = 'sa-qty-atc';
    anchor.parentNode.insertBefore(row, anchor);
    row.appendChild(qtyItem);
    row.appendChild(atc);
    if (oldRow && oldRow.parentNode) oldRow.parentNode.removeChild(oldRow);
    var rest = form.querySelectorAll('.sa-qty-atc');
    for (var j = 0; j < rest.length; j++) { if (rest[j] !== row) rest[j].parentNode.removeChild(rest[j]); }
  }
 
  /* ---------- 3. Consegna stimata ---------- */
  function initEta(bar) {
    if (bar.dataset.saEtaReady) return;
    bar.dataset.saEtaReady = '1';
    var label = bar.querySelector('[data-sa-eta-label]');
    var cutoff = (bar.dataset.cutoff || '').trim();
    var m = /^(\d{1,2}):(\d{2})$/.exec(cutoff);
    if (!label || !m) return;
    var shipDays = (bar.dataset.shipDays || '1,2,3,4').split(',').map(function (d) { return parseInt(d, 10); }).filter(function (d) { return d >= 1 && d <= 7; });
    if (!shipDays.length) return;
    var transit = parseInt(bar.dataset.transit, 10) || 1;
    var now = new Date();
    var isoDay = function (d) { var w = d.getDay(); return w === 0 ? 7 : w; };
    var beforeCutoff = now.getHours() < parseInt(m[1], 10) || (now.getHours() === parseInt(m[1], 10) && now.getMinutes() < parseInt(m[2], 10));
    var ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var shipsToday = shipDays.indexOf(isoDay(ship)) !== -1 && beforeCutoff;
    if (!shipsToday) {
      for (var i = 1; i <= 8; i++) {
        ship.setDate(ship.getDate() + 1);
        if (shipDays.indexOf(isoDay(ship)) !== -1) break;
      }
    }
    var eta = new Date(ship.getTime());
    eta.setDate(eta.getDate() + transit);
    var fmt;
    try { fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' }).format(eta); }
    catch (e) { fmt = eta.getDate() + '.' + (eta.getMonth() + 1) + '.'; }
    var text = (bar.dataset.text || 'Voraussichtliche Lieferung: {datum}').replace('{datum}', fmt);
    if (shipsToday && bar.dataset.cutoffText) text += ' · ' + bar.dataset.cutoffText.replace('{uhrzeit}', cutoff);
    label.textContent = text;
  }
 
  /* ---------- 4. Video "Come prepararli": play al click, un video alla volta ---------- */
  function initHowto(media) {
    if (media.dataset.saHowtoReady) return;
    media.dataset.saHowtoReady = '1';
    var video = media.querySelector('video');
    var play = media.querySelector('.sa-howto__play');
    if (!video) return;
    function start() {
      document.querySelectorAll('.sa-howto__media.is-playing video').forEach(function (v) { if (v !== video) v.pause(); });
      video.controls = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (play) play.addEventListener('click', start);
    video.addEventListener('play', function () { media.classList.add('is-playing'); });
    video.addEventListener('pause', function () { if (video.currentTime === 0 || video.ended) media.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { media.classList.remove('is-playing'); video.controls = false; });
  }
 
  /* ---------- 5. Bundle: aggiunge insieme tutti i prodotti della combinazione ---------- */
  function initBundle(btn) {
    if (btn.dataset.saBdlReady) return;
    btn.dataset.saBdlReady = '1';
    btn.addEventListener('click', function () {
      var ids = (btn.dataset.variantIds || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
      if (!ids.length) return;
      btn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = root + 'cart';
      }).catch(function () {
        btn.disabled = false;
        if (btn.dataset.error) btn.textContent = btn.dataset.error;
      });
    });
  }
 
  /* ---------- 6. Recensioni: "Alle Bewertungen" apre il widget completo ---------- */
  function initReviews(root) {
    if (root.dataset.saRvReady) return;
    root.dataset.saRvReady = '1';
    var more = root.querySelector('.sa-rv__more');
    if (more) more.addEventListener('click', function () { root.classList.add('is-open'); });
  }
 
  /* ---------- 7. Barra acquisto fissa (snippets/sa-de-sticky-atc.liquid) ----------
     Compare quando la riga quantita' + Add to Cart del form e' uscita dallo schermo verso l'alto
     (IntersectionObserver), sparisce quando la riga torna visibile, quando il carrello a scomparsa e'
     aperto o mentre il banner cookie iubenda e' visibile. Prezzo e quantita' = card AOV attiva
     (stesso prezzo Mix & Match del prezzo grande), altrimenti il prezzo grande del form.
     Il pulsante clicca il pulsante Add to Cart vero: stesso invio del form, stesso carrello a scomparsa. */
  var stickyBars = [];
  var stickyMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function stickyForm(bar) { return document.getElementById(bar.dataset.formId); }
  function stickyMainBtn(form) {
    return form && (form.querySelector('.sa-qty-atc .product-form__add-button') || form.querySelector('.product-form__add-button'));
  }
  function stickyTarget(form) {
    return form && (form.querySelector('.sa-qty-atc') || form.querySelector('.product-form__buy-buttons') || stickyMainBtn(form));
  }
  function stickyText(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('.visually-hidden'), function (h) { h.parentNode.removeChild(h); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function stickyRender(bar) {
    var form = stickyForm(bar);
    if (!form) return;
    var cur = '', old = '';
    var qtyEl = form.querySelector('input[name="quantity"]');
    var q = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var aov = form.querySelector('[data-sa-aov]');
    var active = aov && aov.querySelector('.sa-aov__card.is-active');
    if (active) {
      cur = stickyText(active.querySelector('.sa-aov__current'));
      old = stickyText(active.querySelector('.sa-aov__old'));
    } else {
      cur = stickyText(form.querySelector('.price-list .price:not(.price--compare)'));
      old = stickyText(form.querySelector('.price-list .price--compare'));
    }
    var curEl = bar.querySelector('.sa-sticky-atc__current');
    var oldEl = bar.querySelector('.sa-sticky-atc__old');
    var qEl = bar.querySelector('.sa-sticky-atc__qty');
    if (curEl && cur) curEl.textContent = cur;
    if (oldEl) { oldEl.textContent = old; oldEl.hidden = !old; }
    if (qEl) {
      var label = q === 1 ? (bar.dataset.unitS || '') : (bar.dataset.unitP || '');
      qEl.textContent = q > 1 ? '· ' + q + ' ' + label : '';
      qEl.hidden = !(q > 1);
    }
    /* Stato del pulsante = stato del pulsante vero (esaurito, preordine, non disponibile) */
    var main = stickyMainBtn(form);
    var btn = bar.querySelector('.sa-sticky-atc__btn');
    if (btn && main && !btn.classList.contains('is-loading')) {
      var off = main.disabled || main.classList.contains('button--disabled');
      btn.disabled = off;
      btn.classList.toggle('is-disabled', off);
      var key = main.getAttribute('data-sa-i18n');
      if (key && key !== btn.getAttribute('data-sa-i18n')) {
        btn.setAttribute('data-sa-i18n', key);
        var ms = main.querySelector('.sa-i18n'), bs = btn.querySelector('.sa-i18n');
        if (ms && bs) bs.textContent = ms.textContent;
      }
    }
  }
  function stickyDrawerOpen() {
    if (document.documentElement.classList.contains('smart-cart-is-open')) return true;
    var mc = document.getElementById('mini-cart');
    return !!mc && mc.getAttribute('aria-hidden') === 'false';
  }
  function stickyCookieBanner() {
    var b = document.getElementById('iubenda-cs-banner');
    if (!b) return false;
    var s = window.getComputedStyle(b);
    return s.display !== 'none' && s.visibility !== 'hidden' && b.offsetHeight > 0;
  }
  function stickyEvaluate() {
    var anyOn = false;
    stickyBars.forEach(function (bar) {
      if (!bar.isConnected) return;
      var allowed = bar.dataset.desktop === '1' || !stickyMq || stickyMq.matches;
      var on = allowed && bar._saPast === true && !stickyDrawerOpen() && !stickyCookieBanner();
      if (on) anyOn = true;
      if (bar.classList.contains('is-visible') === on) return;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    });
    document.documentElement.classList.toggle('sa-sticky-on', anyOn);
  }
  function initSticky(bar) {
    var form = stickyForm(bar);
    var target = stickyTarget(form);
    if (!bar.dataset.saStickyReady) {
      bar.dataset.saStickyReady = '1';
      stickyBars.push(bar);
      var btn = bar.querySelector('.sa-sticky-atc__btn');
      if (btn) btn.addEventListener('click', function () {
        var f = stickyForm(bar);
        var main = stickyMainBtn(f);
        if (!main || main.disabled || btn.disabled) return;
        /* Kit: stessa aggiunta dei prodotti componenti del pulsante principale (sezione 8), mai main.click() */
        if (kitIds(f)) { kitAdd(f, btn); return; }
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        clearTimeout(bar._saLoad);
        bar._saLoad = setTimeout(function () { stickyDone(bar); }, 4000);
        main.click();
      });
    }
    /* Il form viene ricreato dal tema al cambio variante: si osserva sempre la riga attuale */
    if (target && target !== bar._saTarget && 'IntersectionObserver' in window) {
      if (bar._saIo) bar._saIo.disconnect();
      bar._saTarget = target;
      bar._saIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar._saPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        });
        stickyEvaluate();
      });
      bar._saIo.observe(target);
    }
    stickyRender(bar);
  }
  function stickyDone(bar) {
    clearTimeout(bar._saLoad);
    var btn = bar.querySelector('.sa-sticky-atc__btn');
    if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    stickyRender(bar);
  }
  function stickyRenderAll() { stickyBars.forEach(function (b) { if (b.isConnected) stickyRender(b); }); }
  document.addEventListener('sa:aov:sync', stickyRenderAll);
  document.addEventListener('variant:changed', function () { setTimeout(stickyRenderAll, 0); });
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') stickyRenderAll(); });
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') stickyRenderAll(); });
  ['product:added', 'cart:rerendered', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      stickyBars.forEach(function (b) { if (b.querySelector('.sa-sticky-atc__btn.is-loading')) setTimeout(function () { stickyDone(b); }, 300); });
      setTimeout(stickyEvaluate, 400);
    });
  });
  if (window.MutationObserver) {
    new MutationObserver(stickyEvaluate).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    var stickyMc = function () {
      var mc = document.getElementById('mini-cart');
      if (mc && !mc.dataset.saStickyObs) {
        mc.dataset.saStickyObs = '1';
        new MutationObserver(stickyEvaluate).observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickyMc); else stickyMc();
  }
  var stickyRaf = null;
  window.addEventListener('scroll', function () {
    if (stickyRaf || !stickyBars.length) return;
    var run = function () { stickyRaf = null; stickyEvaluate(); };
    stickyRaf = window.requestAnimationFrame ? window.requestAnimationFrame(run) : setTimeout(run, 16);
  }, { passive: true });
  if (stickyMq) {
    if (stickyMq.addEventListener) stickyMq.addEventListener('change', stickyEvaluate);
    else if (stickyMq.addListener) stickyMq.addListener(stickyEvaluate);
  }
 
  /* ---------- 8. Kit: il prodotto kit non entra mai nel carrello ----------
     Prodotti con il metafield custom.kit_komponenten: snippets/product-buy-buttons.liquid scrive gli ID delle
     varianti componenti in data-sa-kit (dentro il form prodotto) e rende il pulsante type="button".
     Qui, in fase di cattura su window (prima di qualsiasi script del tema):
     - click sul pulsante Add to Cart del form kit -> stop dell'evento, POST /cart/add.js con i componenti;
     - submit del form kit (Invio, requestSubmit, script terzi) -> stop dell'invio nativo, stessa aggiunta;
     - click nei pulsanti di pagamento rapido di un form kit -> bloccato (non vengono stampati, difesa in piu').
     La barra fissa (sezione 7) chiama kitAdd direttamente. Quantita' = selettore quantita' del form, la stessa
     per ogni componente. Il carrello a scomparsa si apre e si aggiorna subito con l'HTML della sezione
     mini-cart restituito da /cart/add.js (saCartAfterAdd, qui sopra); con il carrello a pagina si va su /cart. */
  function kitIds(form) {
    var el = form && form.querySelector ? form.querySelector('[data-sa-kit]') : null;
    if (!el) return null;
    var ids = (el.getAttribute('data-sa-kit') || '').split(',').map(function (x) { return parseInt(x, 10); })
      .filter(function (x) { return x > 0; });
    return ids.length ? ids : null;
  }
  function kitMsg(form, text) {
    var el = form.querySelector('[data-sa-kit-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }
  function kitBusy(btns, on) {
    btns.forEach(function (b) {
      if (!b) return;
      b.classList.toggle('sa-kit-loading', on);
      b.classList.toggle('is-loading', on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }
  /* Carrello a scomparsa dopo un'aggiunta AJAX (kit e bundle): aperto e aggiornato SUBITO.
     - La richiesta /cart/add.js chiede anche la sezione "mini-cart" (Section Rendering API: sections +
       sections_url): la risposta contiene gia' l'HTML nuovo del carrello. Si sostituisce il CONTENUTO di
       form#mini-cart (non l'elemento: restano aria-hidden e classi, quindi resta aperto), si aggiorna il
       numero nell'header (.header__cart-count) e si apre il carrello se e' chiuso (click sul pulsante
       carrello dell'header, mai se e' gia' aperto).
     - Poi 'cart:rerendered' su <html> (bubbles): Smart Cart guard, barra/upsell e card AOV si aggiornano.
     - Infine 'product:added' per compatibilita' con il tema; se il ridisegno del tema richiude il
       carrello entro 3 s senza un'azione del cliente, viene riaperto.
     - Riserve: senza sezione nella risposta si chiede una volta /?sections=mini-cart; se anche questa
       fallisce resta il ridisegno del tema, con il contenuto attenuato al massimo 1,2 s. */
  var saCartLoadTimer = null;
  function saCartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function saCartIsOpen() {
    var mc = document.getElementById('mini-cart');
    return !!mc && mc.getAttribute('aria-hidden') === 'false';
  }
  function saCartToggleOpen() {
    if (saCartIsOpen()) return true;
    var toggle = document.querySelector('[aria-controls="mini-cart"][data-action="toggle-mini-cart"], [aria-controls="mini-cart"]');
    if (toggle) toggle.click();
    return saCartIsOpen();
  }
  function saCartLoading(on, maxMs) {
    var mc = document.getElementById('mini-cart');
    clearTimeout(saCartLoadTimer);
    if (on && !document.getElementById('sa-cart-loading-css')) {
      var st = document.createElement('style');
      st.id = 'sa-cart-loading-css';
      st.textContent = '#mini-cart.sa-cart-loading{cursor:progress}#mini-cart.sa-cart-loading>*{opacity:.55;transition:opacity .2s}';
      document.head.appendChild(st);
    }
    if (mc) {
      mc.classList.toggle('sa-cart-loading', !!on);
      if (on) mc.setAttribute('aria-busy', 'true'); else mc.removeAttribute('aria-busy');
    }
    if (on) saCartLoadTimer = setTimeout(function () { saCartLoading(false); }, maxMs || 1200);
  }
  /* Parametri da aggiungere al corpo JSON di /cart/add.js */
  function saCartSectionsBody(body) {
    if (document.getElementById('mini-cart')) {
      body.sections = 'mini-cart';
      body.sections_url = window.location.pathname;
    }
    return body;
  }
  /* Sostituisce il contenuto di form#mini-cart con l'HTML della sezione; true se riuscito */
  function saCartApply(html) {
    var live = document.getElementById('mini-cart');
    if (!html || !live || !window.DOMParser) return false;
    var fresh;
    try { fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('mini-cart'); } catch (e) { return false; }
    if (!fresh) return false;
    live.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-item-count');
    if (count !== null) {
      live.setAttribute('data-item-count', count);
      Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count'), function (el) { el.textContent = count; });
    }
    return true;
  }
  /* Per 3 s riapre il carrello se un ridisegno del tema lo chiude senza un'azione del cliente */
  function saCartKeepOpen() {
    var mc = document.getElementById('mini-cart');
    if (!mc || !window.MutationObserver) return;
    var user = false, obs;
    function onUser(e) { if (e.isTrusted) user = true; }
    function stop() {
      if (obs) obs.disconnect();
      document.removeEventListener('click', onUser, true);
      document.removeEventListener('keydown', onUser, true);
    }
    document.addEventListener('click', onUser, true);
    document.addEventListener('keydown', onUser, true);
    obs = new MutationObserver(function () {
      var el = document.getElementById('mini-cart');
      if (user) { stop(); return; }
      if (el && el.getAttribute('aria-hidden') === 'true') { stop(); saCartToggleOpen(); }
    });
    obs.observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] });
    setTimeout(stop, 3000);
  }
  function saCartFire(name, detail) {
    document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }
  /* Dopo /cart/add.js riuscito: data = risposta JSON, qty = pezzi aggiunti */
  function saCartAfterAdd(data, qty) {
    if (window.theme && window.theme.cartType === 'page') { window.location.href = saCartRoot() + 'cart'; return; }
    function finish(ok) {
      saCartToggleOpen();
      if (ok) {
        saCartLoading(false);
        saCartFire('cart:rerendered');
      } else {
        saCartLoading(true, 1200);
      }
      saCartKeepOpen();
      saCartFire('product:added', { quantity: qty });
    }
    var html = data && data.sections && data.sections['mini-cart'];
    if (html && saCartApply(html)) { finish(true); return; }
    /* Riserva: carrello aperto subito, contenuto chiesto a parte */
    saCartToggleOpen();
    saCartLoading(true, 4000);
    var url = saCartRoot() + '?sections=mini-cart';
    (window.saAovFetch || window.fetch).call(window, url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) { finish(saCartApply(json && json['mini-cart'])); })
      .catch(function () { finish(false); });
  }
  function kitAdd(form, extraBtn) {
    var ids = kitIds(form);
    if (!ids || form.dataset.saKitBusy === '1') return;
    var main = stickyMainBtn(form);
    if (main && main.disabled) return;
    var qtyEl = form.querySelector('input[name="quantity"]');
    var q = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var items = ids.map(function (id) { return { id: id, quantity: q }; });
    var btns = [main, extraBtn && extraBtn !== main ? extraBtn : null];
    var holder = form.querySelector('[data-sa-kit]');
    var fallback = (holder && holder.getAttribute('data-sa-kit-fallback')) || '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    form.dataset.saKitBusy = '1';
    kitMsg(form, '');
    kitBusy(btns, true);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(saCartSectionsBody({ items: items }))
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        form.dataset.saKitBusy = '';
        kitBusy(btns, false);
        saCartAfterAdd(data, q * ids.length);
      })
      .catch(function (err) {
        form.dataset.saKitBusy = '';
        kitBusy(btns, false);
        kitMsg(form, (err && (err.description || err.message)) || fallback);
        /* Se una parte e' comunque entrata, il carrello a scomparsa si riallinea */
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  }
  function kitFormOf(node) {
    if (!node || !node.closest) return null;
    var f = node.form || node.closest('form');
    return f && kitIds(f) ? f : null;
  }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var pay = t.closest('.shopify-payment-button, shopify-accelerated-checkout');
    var btn = t.closest('.product-form__add-button, button[type="submit"], input[type="submit"]');
    var form = kitFormOf(pay || btn);
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (pay || btn.disabled) return;
    kitAdd(form, null);
  }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !kitIds(form)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    kitAdd(form, null);
  }, true);
  function initKit(form) {
    if (!kitIds(form) || form.hasAttribute('data-sa-kit-form')) return;
    form.setAttribute('data-sa-kit-form', '');
  }
 
  function boot() {
    document.querySelectorAll('[data-sa-aov]').forEach(initAov);
    document.querySelectorAll('form.product-form').forEach(initQtyRow);
    document.querySelectorAll('[data-sa-sticky]').forEach(initSticky);
    document.querySelectorAll('form').forEach(initKit);
    document.querySelectorAll('[data-sa-eta]').forEach(initEta);
    document.querySelectorAll('.sa-howto__media').forEach(initHowto);
    document.querySelectorAll('[data-sa-bundle]').forEach(initBundle);
    document.querySelectorAll('.sa-rv').forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  /* Dopo un re-render parziale del tema (cambio variante) il DOM del form viene ricreato: si rifà tutto. */
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; boot(); }, 60);
  });
  document.querySelectorAll('product-rerender').forEach(function (el) { mo.observe(el, { childList: true, subtree: true }); });
})();
 